// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e0Br","label":"styles_label__1mRiI"};